const FacebookLogo = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_98_265)">
        <path
          d="M20 10C20 4.47656 15.5234 0 10 0C4.47656 0 0 4.47656 0 10C0 14.9918 3.65469 19.1289 8.43828 19.8793V12.893H5.90117V10H8.43828V7.79727C8.43828 5.29297 9.92852 3.90703 12.2137 3.90703C13.3094 3.90703 14.4547 4.1043 14.4547 4.1043V6.56445H13.1945C11.9508 6.56445 11.5672 7.33711 11.5672 8.12617V10H14.3398L13.8961 12.893H11.5672V19.8793C16.3453 19.1289 20 14.9918 20 10Z"
          fill="#1877F2"
        />
        <path
          d="M13.8902 12.893L14.3344 10H11.5617V8.12617C11.5617 7.33711 11.9508 6.56445 13.1891 6.56445H14.4492V4.1043C14.4492 4.1043 13.3039 3.90703 12.2082 3.90703C9.92344 3.90703 8.43281 5.29336 8.43281 7.79727V10H5.8957V12.893H8.43281V19.8793C8.94258 19.9613 9.46289 20 9.99453 20C10.5262 20 11.0465 19.9563 11.5563 19.8793V12.893H13.8902Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_98_265">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default FacebookLogo;
